import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import AlertTypeService from "../../src/Services/AlertType.service";
const AlertTypeLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return AlertTypeService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return AlertTypeService.getAlertTypes(search);
        },
        optionRenderer: function alertTypeRenderer(alertType) {
            return _jsx("span", { children: alertType.name });
        },
    });
};
export default AlertTypeLookup;
